var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6668 1.3335C13.2833 1.3335 12.8996 1.47996 12.6069 1.7723L11.7814 2.59782L13.9025 4.71891L14.728 3.89339C15.3127 3.30806 15.3127 2.35893 14.728 1.7736L14.7267 1.7723C14.4341 1.47996 14.0503 1.3335 13.6668 1.3335ZM3.3335 2.66683C1.95283 2.66683 0.833496 3.78616 0.833496 5.16683V13.1668C0.833496 14.5475 1.95283 15.6668 3.3335 15.6668H11.3335C12.7142 15.6668 13.8335 14.5475 13.8335 13.1668V7.40251C13.8335 7.12651 13.6095 6.90251 13.3335 6.90251C13.0575 6.90251 12.8335 7.12651 12.8335 7.40251V13.1668C12.8335 13.9955 12.1622 14.6668 11.3335 14.6668H3.3335C2.50483 14.6668 1.8335 13.9955 1.8335 13.1668V5.16683C1.8335 4.33816 2.50483 3.66683 3.3335 3.66683H9.09782C9.37382 3.66683 9.59782 3.44283 9.59782 3.16683C9.59782 2.89083 9.37382 2.66683 9.09782 2.66683H3.3335ZM11.0731 3.30485L6.7124 7.66553C6.65774 7.72019 6.61728 7.78814 6.59261 7.86214L5.88558 9.98324C5.82558 10.1626 5.87267 10.3597 6.00667 10.4937C6.14067 10.6277 6.33776 10.6747 6.51709 10.6147L8.63818 9.90771C8.71218 9.88305 8.78013 9.84259 8.8348 9.78792L13.1955 5.42725L11.0731 3.30485Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0746939f2ac1e3fbb454f84b8671f30b.svg";
export { ForwardRef as ReactComponent };